export const openCreateSkillDialogReducer = (state) => {
    state.createSkillDialog.isOpen = true;
    state.createNewSkill.status = "idle";
    state.createNewSkill.errorMessage = "";
}
